import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import "md-editor-v3/lib/style.css";
import { MdEditor } from "md-editor-v3";
import { ref } from "vue";
import { uploadFileUsingPost } from "@/request/api/fileController";
import { Message } from "@arco-design/web-vue";

/**
 * 定义组件属性类型
 */
interface Props {
  mdText: string;
  onChange?: (text: string) => void;
}

/**
 * 给组件指定初始值
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'MdEditor',
  props: {
    mdText: { default: () => "" },
    onChange: {}
  },
  setup(__props: any) {

const props = __props;
const text = ref(props.mdText);

const handleChange = (value: string) => {
  text.value = value;
};
// 图片上传事件
const onUploadImg = async (
  files: (string | Blob)[],
  callback: (arg0: any[]) => void
) => {
  const res = await Promise.all(
    files.map((file: string | Blob) => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (rev, rej) => {
        // 传给后端一个FormData数据，添加键值对，这里我添加了这个文章的ID和file
        const res = (await uploadFileUsingPost(
          { biz: "md" },
          {},
          file as File
        )) as any;
        if (res.data.code == 0 && res.data.data) {
          rev(res.data.data);
        } else {
          rej(res.data.message);
        }
      });
    })
  );
  callback(res);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MdEditor), {
    modelValue: text.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
    onChange: handleChange,
    onOnUploadImg: onUploadImg
  }, null, 8, ["modelValue"]))
}
}

})